import {
  INVEST_PDF_OKRAJ_X,
  INVEST_PDF_SIRKA_OBSAHU,
  zabezpecInvestPdfMiesto,
} from "./investPdfPomocne";

const FARBA_NADPIS = [
  120,
  102,
  67,
];

const FARBA_TEXT = [
  45,
  45,
  45,
];

const FARBA_JEMNA = [
  110,
  110,
  110,
];

const FARBA_LINKA = [
  205,
  196,
  177,
];

const FARBA_POZNAMKA = [
  248,
  245,
  238,
];

const INVEST_PDF_GRAFY_ROZLOZENIE =
  Object.freeze({
    padding: 4,
    vyskaNadpisu: 8,
    vyskaNazvuGrafu: 6,
    vyskaGrafu: 50,
    medzeraStlpcov: 3,
    medzeraPoznamok: 1.5,
    medzeraKarietPoznamok: 2,
    pomerZlozenie: 0.5,
    vyskaRiadkaPoznamky: 3.1,
    paddingPoznamky: 1.4,
  });

function normalizujRiadkyPoznamky(
  poznamka
) {
  const zdrojoveRiadky =
    Array.isArray(
      poznamka?.riadky
    )
      ? poznamka.riadky
      : poznamka?.text
      ? [
          {
            text: poznamka.text,
            zvyraznit: true,
          },
        ]
      : [];

  return zdrojoveRiadky
    .map((riadok) => {
      if (
        riadok &&
        typeof riadok === "object"
      ) {
        return {
          text: String(
            riadok.text || ""
          ).trim(),
          zvyraznit: Boolean(
            riadok.zvyraznit
          ),
        };
      }

      return {
        text: String(
          riadok || ""
        ).trim(),
        zvyraznit: false,
      };
    })
    .filter(
      (riadok) => riadok.text
    );
}

function normalizujPoznamky(
  poznamky
) {
  return (
    Array.isArray(poznamky)
      ? poznamky
      : []
  )
    .map((poznamka) => ({
      label: String(
        poznamka?.label || ""
      ).trim(),
      riadky:
        normalizujRiadkyPoznamky(
          poznamka
        ),
    }))
    .filter(
      (poznamka) =>
        poznamka.label ||
        poznamka.riadky.length > 0
    );
}

function pripravPoznamky(
  pdf,
  poznamky,
  sirka
) {
  const {
    vyskaRiadkaPoznamky,
    paddingPoznamky,
  } =
    INVEST_PDF_GRAFY_ROZLOZENIE;

  const maximalnaSirka =
    sirka -
    paddingPoznamky * 2;

  return normalizujPoznamky(
    poznamky
  ).map((poznamka) => {
    const riadky =
      poznamka.riadky.flatMap(
        (riadok) => {
          pdf.setFont(
            "Inter",
            riadok.zvyraznit
              ? "bold"
              : "normal"
          );

          pdf.setFontSize(
            riadok.zvyraznit
              ? 6.7
              : 6.2
          );

          const rozdeleneRiadky =
            pdf.splitTextToSize(
              riadok.text,
              maximalnaSirka
            );

          return (
            Array.isArray(
              rozdeleneRiadky
            )
              ? rozdeleneRiadky
              : [rozdeleneRiadky]
          )
            .map((text) => ({
              text: String(
                text || ""
              ).trim(),
              zvyraznit:
                riadok.zvyraznit,
            }))
            .filter(
              (polozka) =>
                polozka.text
            );
        }
      );

    const vyska =
      paddingPoznamky * 2 +
      (
        poznamka.label
          ? vyskaRiadkaPoznamky
          : 0
      ) +
      Math.max(
        1,
        riadky.length
      ) *
        vyskaRiadkaPoznamky;

    return {
      ...poznamka,
      riadky,
      vyska,
    };
  });
}

function vypocitajVyskuPoznamok(
  poznamky
) {
  return poznamky.reduce(
    (maximalnaVyska, poznamka) =>
      Math.max(
        maximalnaVyska,
        poznamka.vyska
      ),
    0
  );
}

function pridajObrazokContain(
  pdf,
  obrazok,
  x,
  y,
  sirka,
  vyska
) {
  if (!obrazok) {
    return;
  }

  const vlastnosti =
    pdf.getImageProperties(
      obrazok
    );

  const povodnaSirka =
    Number(
      vlastnosti?.width
    ) || 1;

  const povodnaVyska =
    Number(
      vlastnosti?.height
    ) || 1;

  const mierka = Math.min(
    sirka / povodnaSirka,
    vyska / povodnaVyska
  );

  const cielovaSirka =
    povodnaSirka * mierka;

  const cielovaVyska =
    povodnaVyska * mierka;

  pdf.addImage(
    obrazok,
    "PNG",
    x +
      (
        sirka -
        cielovaSirka
      ) /
        2,
    y +
      (
        vyska -
        cielovaVyska
      ) /
        2,
    cielovaSirka,
    cielovaVyska,
    undefined,
    "FAST"
  );
}

function zapisPoznamkyVRiadku(
  pdf,
  poznamky,
  x,
  y,
  sirkaPoznamky,
  vyskaPoznamok
) {
  const {
    medzeraKarietPoznamok,
    vyskaRiadkaPoznamky,
    paddingPoznamky,
  } =
    INVEST_PDF_GRAFY_ROZLOZENIE;

  poznamky.forEach(
    (poznamka, index) => {
      const poznamkaX =
        x +
        index *
          (
            sirkaPoznamky +
            medzeraKarietPoznamok
          );

      pdf.setFillColor(
        ...FARBA_POZNAMKA
      );

      pdf.setDrawColor(
        ...FARBA_LINKA
      );

      pdf.setLineWidth(0.2);

      pdf.roundedRect(
        poznamkaX,
        y,
        sirkaPoznamky,
        vyskaPoznamok,
        2,
        2,
        "FD"
      );

      let textY =
        y +
        paddingPoznamky +
        2.2;

      if (poznamka.label) {
        pdf.setTextColor(
          ...FARBA_JEMNA
        );

        pdf.setFont(
          "Inter",
          "normal"
        );

        pdf.setFontSize(6.2);

        pdf.text(
            poznamka.label,
            poznamkaX +
                sirkaPoznamky / 2,
            textY,
            {
                align: "center",
            }
            );

        textY +=
          vyskaRiadkaPoznamky;
      }

      poznamka.riadky.forEach(
        (riadok) => {
          pdf.setTextColor(
            ...FARBA_TEXT
          );

          pdf.setFont(
            "Inter",
            riadok.zvyraznit
              ? "bold"
              : "normal"
          );

          pdf.setFontSize(
            riadok.zvyraznit
              ? 6.7
              : 6.2
          );

          pdf.text(
            riadok.text,
            poznamkaX +
              sirkaPoznamky / 2,
            textY,
            {
              align: "center",
            }
          );

          textY +=
            vyskaRiadkaPoznamky;
        }
      );
    }
  );
}

export function zapisInvestPdfGrafy(
  pdf,
  stav,
  grafy
) {
  const zlozenie =
    grafy?.zlozenie;

  const vyvoj =
    grafy?.vyvoj;

  if (
    !zlozenie?.obrazok ||
    !vyvoj?.obrazok
  ) {
    return;
  }

  const {
    padding,
    vyskaNadpisu,
    vyskaNazvuGrafu,
    vyskaGrafu,
    medzeraStlpcov,
    medzeraPoznamok,
    medzeraKarietPoznamok,
    pomerZlozenie,
  } =
    INVEST_PDF_GRAFY_ROZLOZENIE;

  const vnutornaSirka =
    INVEST_PDF_SIRKA_OBSAHU -
    padding * 2;

  const pouzitelnaSirka =
    vnutornaSirka -
    medzeraStlpcov;

  const sirkaZlozenia =
    pouzitelnaSirka *
    pomerZlozenie;

  const sirkaVyvoja =
    pouzitelnaSirka -
    sirkaZlozenia;

  const zdrojovePoznamky = [
    ...(
        Array.isArray(
        zlozenie.poznamky
        )
        ? zlozenie.poznamky
        : []
    ),
    ...(
        Array.isArray(
        vyvoj.poznamky
        )
        ? vyvoj.poznamky
        : []
    ),
    ];

    const pocetPoznamok =
    normalizujPoznamky(
        zdrojovePoznamky
    ).length;

    const sirkaPoznamky =
    pocetPoznamok > 0
        ? (
            vnutornaSirka -
            medzeraKarietPoznamok *
            (
                pocetPoznamok -
                1
            )
        ) /
            pocetPoznamok
        : vnutornaSirka;

    const pripravenePoznamky =
    pripravPoznamky(
        pdf,
        zdrojovePoznamky,
        sirkaPoznamky
    );

    const vyskaPoznamok =
    vypocitajVyskuPoznamok(
        pripravenePoznamky
    );

  const vyskaStlpca =
    vyskaNazvuGrafu +
    vyskaGrafu +
    (
        vyskaPoznamok > 0
        ? medzeraPoznamok
        : 0
    ) +
    vyskaPoznamok;

  const vyskaKarty =
    padding * 2 +
    vyskaNadpisu +
    vyskaStlpca;

  zabezpecInvestPdfMiesto(
    pdf,
    stav,
    vyskaKarty + 5
  );

  const x =
    INVEST_PDF_OKRAJ_X;

  const y = stav.y;

  pdf.setFillColor(
    255,
    255,
    255
  );

  pdf.setDrawColor(
    ...FARBA_LINKA
  );

  pdf.setLineWidth(0.35);

  pdf.roundedRect(
    x,
    y,
    INVEST_PDF_SIRKA_OBSAHU,
    vyskaKarty,
    3,
    3,
    "FD"
  );

  pdf.setTextColor(
    ...FARBA_NADPIS
  );

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(9.2);

  pdf.text(
    "Grafické zobrazenie výsledku",
    x + padding,
    y + padding + 4.5
  );

  const obsahY =
    y +
    padding +
    vyskaNadpisu;

  const zlozenieX =
    x + padding;

  const vyvojX =
    zlozenieX +
    sirkaZlozenia +
    medzeraStlpcov;

  pdf.setTextColor(
    ...FARBA_NADPIS
  );

  pdf.setFont(
    "Inter",
    "bold"
  );

  pdf.setFontSize(7.3);

  pdf.text(
    "Zloženie",
    zlozenieX,
    obsahY + 4
  );

  pdf.text(
    "Vývoj",
    vyvojX,
    obsahY + 4
  );

  const grafY =
    obsahY +
    vyskaNazvuGrafu;

  pridajObrazokContain(
    pdf,
    zlozenie.obrazok,
    zlozenieX,
    grafY,
    sirkaZlozenia,
    vyskaGrafu
  );

  pridajObrazokContain(
    pdf,
    vyvoj.obrazok,
    vyvojX,
    grafY,
    sirkaVyvoja,
    vyskaGrafu
  );

  const poznamkyY =
    grafY +
    vyskaGrafu +
    (
        vyskaPoznamok > 0
        ? medzeraPoznamok
        : 0
    );

    if (
    pripravenePoznamky.length > 0
    ) {
    zapisPoznamkyVRiadku(
        pdf,
        pripravenePoznamky,
        x + padding,
        poznamkyY,
        sirkaPoznamky,
        vyskaPoznamok
    );
    }

  stav.y =
    y +
    vyskaKarty +
    5;
}